
import React, { useState } from 'react';
import { Instagram, MessageSquare } from 'lucide-react';
import { 
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const Footer: React.FC = () => {
  const [disclaimerOpen, setDisclaimerOpen] = useState(false);
  
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/605216064', '_blank');
  };
  
  return (
    <footer className="bg-vegana-primary text-white py-8 relative z-20">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center justify-center">
          <div className="mb-6 flex flex-col items-center">
            <img 
              src="/lovable-uploads/736698b6-3295-4fc0-a4b1-79cda8db1f79.png" 
              alt="Guía Vegana Logo" 
              className="w-20 h-20 rounded-full border-2 border-white shadow-md" 
            />
            <h3 className="text-xl font-semibold text-center mt-2">Guía Vegana</h3>
          </div>
          
          <p className="text-gray-300 mb-6 text-center max-w-md">
            Tu plataforma de nutrición vegana para una vida saludable y sostenible.
          </p>
          
          <div className="flex items-center justify-center space-x-6 mb-6">
            <a href="https://www.instagram.com/guia_vegana" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-300 transition-colors">
              <Instagram size={24} />
            </a>
            <button 
              onClick={handleWhatsAppClick}
              className="text-white hover:text-gray-300 transition-colors flex items-center gap-2 bg-[#25D366] hover:bg-[#1fb855] px-3 py-2 rounded-lg"
            >
              <MessageSquare size={20} />
              <span className="text-sm font-medium">Soporte</span>
            </button>
          </div>
          
          <Dialog open={disclaimerOpen} onOpenChange={setDisclaimerOpen}>
            <DialogTrigger asChild>
              <Button variant="ghost" className="text-gray-300 hover:text-white text-sm mb-4">
                Aviso importante sobre el uso de la app
              </Button>
            </DialogTrigger>
            <DialogContent className="max-w-md">
              <DialogHeader>
                <DialogTitle className="text-xl text-vegana-primary mb-4">Información importante</DialogTitle>
              </DialogHeader>
              <DialogDescription className="text-gray-700">
                <div className="space-y-4">
                  <p>
                    En Guía Vegana App tienes acceso directo a nutricionistas reales disponibles 7 días a la semana para resolver tus dudas y acompañarte en tu proceso.
                  </p>
                  <p>
                    Sin embargo, ni la app ni nuestra inteligencia artificial Lisa sustituyen por sí mismas una consulta médica o un diagnóstico profesional.
                    La información que ofrece la app es orientativa y se basa en los datos que introduces.
                  </p>
                  <p className="flex">
                    <span className="mr-2">👉</span> 
                    <span>Si quieres hacer cambios importantes en tu alimentación o estilo de vida, te recomendamos contactar con nuestras nutricionistas a través de la sección 'Soporte'.</span>
                  </p>
                  <p>
                    Ellas están colegiadas y capacitadas para ayudarte de forma personalizada.
                  </p>
                  <p className="flex">
                    <span className="mr-2">⚠️</span>
                    <span>Si estás embarazada, tomas medicación o padeces alguna enfermedad, consulta siempre con nuestros nutricionistas antes de iniciar cambios.</span>
                  </p>
                </div>
              </DialogDescription>
            </DialogContent>
          </Dialog>
        </div>
        
        <div className="mt-6 pt-6 border-t border-gray-700 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Guía Vegana. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
